<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label required">{{
          $t('journalEntry.date')
        }}</label>
        <a-date-picker
          v-model="model.transaction_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          class="ts-w-full"
          :allowClear="false"
          :disabled="isUpdate"
        ></a-date-picker>
        <div class="invalid-feedback" v-if="errors.has('transaction_date')">
          {{ errors.first('transaction_date') }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label required">{{
          $t('journalEntry.currency')
        }}</label>
        <a-select
          v-model="model.currency_id"
          :options="currencies"
          option-filter-prop="children"
          class="ts-w-full"
          :class="{ 'is-invalid': errors.has('expense_type') }"
          placeholder="Select"
          @change="onChangeCurrency"
        ></a-select>
        <div class="invalid-feedback" v-if="errors.has('currency_id')">
          {{ errors.first('currency_id') }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">{{ $t('journalEntry.fxRate') }}</label>
        <input
          type="number"
          v-model.number="model.fx_rate"
          class="form-control"
          :class="{ 'is-invalid': errors.has('fx_rate') }"
          readonly
        />
        <div class="invalid-feedback" v-if="errors.has('fx_rate')">
          {{ errors.first('fx_rate') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label">{{
          $t('journalEntry.referenceNo')
        }}</label>
        <input
          type="text"
          v-model="model.reference_no"
          class="form-control"
          :class="{ 'is-invalid': errors.has('reference_no') }"
        />
        <div class="invalid-feedback" v-if="errors.has('reference_no')">
          {{ errors.first('reference_no') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="col-form-label">{{ $t('journalEntry.remarks') }}</label>
        <textarea
          v-model="model.remarks"
          rows="3"
          class="form-control"
          :class="{ 'is-invalid': errors.has('remarks') }"
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('remarks')">
          {{ errors.first('remarks') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  name: 'basicInfo',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      coaSetupLoading: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('accounting/journalEntry', ['formViewDatas', 'edit_data']),
    currencies() {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].map(el => ({
          value: el.currency_id,
          label: el.currency_description + ' | ' + el.currency_code
        }))
      }
      return []
    },
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('accounting/journalEntry', ['getFormViewModel']),
    async onChangeCurrency(value) {
      this.model.details = []
      this.setFxRate()
      this.coaSetupLoading = true
      await this.getFormViewModel({
        index: 'coaSetups',
        params: {
          fnName: 'coaSetups',
          currency_id: this.model.currency_id
        }
      }).finally(() => {
        this.coaSetupLoading = false
      })
    },
    setFxRate() {
      const currency = this.formViewDatas['currency'].find(
        el => el.currency_id == this.model.currency_id
      )

      this.model.fx_rate = currency.last_exchange_rate
        ? currency.last_exchange_rate.fx_rate
        : 1
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>
<style scoped>
.form-control {
  height: 32px;
}
</style>
